var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 89,
    r: 87.5,
    fill: "#FDF4E8",
    stroke: "#FDE1B6",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.9004 95.4448V109.94",
    stroke: "#E99312",
    strokeWidth: 2.39379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9193 103.923L81.9024 109.94L75.8835 103.921",
    stroke: "#E99312",
    strokeWidth: 2.39379,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.114 63.8008L62.1931 63.7949C61.0887 63.7949 60.1937 62.8992 60.1937 61.7934C60.1937 60.6897 61.0888 59.7953 62.1931 59.7953L112.553 59.7874C113.875 59.7874 114.946 58.7153 114.946 57.3937C114.946 56.0708 113.875 55 112.553 55H60.5857C57.5063 55 55 57.5063 55 60.5857V110.955C55 112.549 56.2926 113.843 57.8887 113.843H64.0281C67.7718 119.726 74.3454 123.641 81.8188 123.641C89.2923 123.641 95.8666 119.727 99.6096 113.843H120.111C121.707 113.843 123 112.55 123 110.955V66.6901C123 65.0947 121.707 63.8008 120.111 63.8008L120.114 63.8008ZM81.8204 119.651C72.3981 119.651 64.7339 111.987 64.7339 102.567C64.7339 101.857 64.7787 101.142 64.8656 100.441C65.9219 91.9118 73.2116 85.4796 81.8206 85.4796C84.0261 85.4796 86.1703 85.8929 88.1955 86.7057C94.7027 89.3239 98.9077 95.548 98.9077 102.566C98.9077 111.987 91.2428 119.653 81.8212 119.653L81.8204 119.651ZM118.585 83.3186H102.938C99.9797 83.3186 97.5821 80.9215 97.5821 77.9638C97.5821 75.0042 99.9797 72.6071 102.938 72.6071H118.584L118.585 83.3186ZM101.171 77.9638C101.171 79.2308 102.198 80.2595 103.467 80.2595C104.736 80.2595 105.763 79.2308 105.763 77.9638C105.763 76.6949 104.736 75.6682 103.467 75.6682C102.198 75.6682 101.171 76.6949 101.171 77.9638Z",
    fill: "#E99312"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWallet);
export default __webpack_public_path__ + "static/media/download_wallet.7ade3a039e115277331dd38f9bb29cbb.svg";
export { ForwardRef as ReactComponent };